<template>
  <div class="p-24">
    <h1 class="heading-1">Hello World - Trade-in Product Page</h1>
    <p class="text-static-default-low body-1">
      Category: {{ route.params.category }}
    </p>
    <p class="text-static-default-low body-1">Slug: {{ route.params.slug }}</p>
    <p class="text-static-default-low body-1">ID: {{ route.params.id }}</p>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'

const route = useRoute()
</script>
